import { render, staticRenderFns } from "./unsalableOverThreshold.vue?vue&type=template&id=9fdc6bf0"
import script from "./unsalableOverThreshold.vue?vue&type=script&lang=js"
export * from "./unsalableOverThreshold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports